import Icon from "../Icon/Icon";
import {useDropzone} from "react-dropzone";
import {ReactComponent as uploadSvg} from "../../assets/upload.svg"
import {ReactComponent as trashSvg} from "../../assets/trash.svg"
import "./PictureDrop.scss"
import React, {useEffect, useState} from "react";
import Button from "../Button/Button";
import imageActions from "../../api/ImagesActions";
import applicationConfiguration from "../../config/applicationConfiguration";


const PictureDrop = ({formik, name}) => {
    const [preview, setPreview] = useState(null);

    const { getRootProps, getInputProps } = useDropzone({
        multiple: false,
        maxFiles: 1,
        onDrop: acceptedFiles => {
            if (acceptedFiles.length > 0) {
                imageActions.uploadImage(acceptedFiles[0], res => {
                    formik.setFieldValue(name, res)
                })
            }
        }
    });

    useEffect(() => {
        if(formik.values[name]?.url){
            setPreview(`${applicationConfiguration.apiUrl}/api/avatars/${formik.values[name].url}`);
        }

    }, [formik.values[name]?.url])


    return(
        <div {...getRootProps()} className="dnd">
            <input {...getInputProps()}/>

            {preview ? (
                <>
                    <Button variant="action">
                        <Icon svg={trashSvg} className="trash" onClick={(e) => {
                            e.preventDefault();
                            formik.setFieldValue(name, null);
                        }}/>
                    </Button>
                    <img src={preview} alt={"preview"} className="preview" />

                </>
            ) : (
                <>
                    <Icon svg={uploadSvg} className="upload"/>
                    Click to Upload or drag and drop
                </>
            )}
        </div>

    )
}

export default PictureDrop;